
import { seasondefaults } from './seasondefaults'

export const eventdefaults = {
    ...seasondefaults,
    currentWizardStep:1,
    eventRetrieved:false,  
    inWizardMode:false,
    eventId:0,
    fetchingevent:false,
    eventcountry : 'US',
    directorcountry : 'US',
    eventname:'',
    startdate:'',
    enddate:'',
    eventnumberofdays:0,
    eventseason:'',
    eventType:'3',
    numberOfGames:null,
    numberOfWeeks:null,
    certificationNumber:null,
    dailyOilRatios:false,
    weeklyOilRatios:false,
    weeklyOilRatiosChangesAfter:1,
    oilRatio:[],
    directorname:'',
    directorssoemail:'',
    directorphone:'',
    directoraddress1:'',
    directoraddress2:'',
    directorcity:'',
    directorstate:'',
    directorzipcode:'',
    eventemail:'',
    seasons:[],
    searching:false,
    pendinguploads:[],
    uploadingfile:false,
    hasDirectorRole:true,
    hasAdminRole:false,
    savingComponentState:false,
    componentStateSaved:false,
    nameoncard:'',
    ccnumber:'',
    expiration:'',
    cvc:'',
    savingDeposit:false,
    rulesApproved:false,
    depositAmount:null,
    minRequiredDeposit:null,
    depositPaidOn:null,
    depositError:'',
    depositConfirmation:'',
    advancerPolicy:'0',
    advancerRatio:null,
    includeEnhancedAdvancerRatio:'false',
    premierEvent:'false',
    useMajorFraction:'false',
    offersScholarship:'false',
    smartProviderId:'',
    mixedAgeDivisions:[],
    updateErrors:{},
    updateDetailsErrors:{},
    updateLaneErrors:{},
    updateSetupErrors:{},
    updateDepositErrors:{},
    updateRulesErrors:{},
    norecordsfound:false,
    mixedAgeDivisionsOffered:[]
}


// WEBPACK FOOTER //
// ./src/utils/constants/eventdefaults.js